import { IconProps } from "../../utils/global-types/global-types";

const LogoutIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <g clipPath="url(#clip0_8372_137422)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.892 14.111v.747a1.6 1.6 0 0 1-.818 1.417c-.25.144-.528.225-.817.225-.29 0-.568-.08-.818-.225l-3.324-1.919a1.6 1.6 0 0 1-.818-1.416V3.136c0-.902.734-1.636 1.636-1.636h7.32c.902 0 1.636.734 1.636 1.636v2.066a.537.537 0 0 1-1.074 0V3.136a.56.56 0 0 0-.562-.562H4.84l3.235 1.869c.52.3.818.817.818 1.416v7.178h2.361c.31 0 .562-.252.562-.562v-1.811a.537.537 0 1 1 1.074 0v1.811c0 .902-.734 1.636-1.636 1.636zm4.977-5.768-.591.591a.537.537 0 1 0 .76.76l1.508-1.509c.21-.21.21-.55 0-.76l-1.508-1.507a.537.537 0 0 0-.76.759l.591.591H9.907a.537.537 0 1 0 0 1.075z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_8372_137422">
        <path fill="currentColor" d="M1.5 1.5h15v15h-15z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default LogoutIcon;
